// Lightweight alerts service for Procurement Assistant
import { BACKEND_BASE_URL } from "../constants";

const getApiBase = () => {
  const base = BACKEND_BASE_URL || "";
  // Ensure no trailing slash
  return String(base).replace(/\/$/, "");
};

/**
 * Fetch Procurement Assistant alerts.
 * Expected response shape:
 * {
 *   ok: true,
 *   generated_at: string,
 *   email: string,
 *   market_intel_alerts: string[],
 *   risk_perf_alerts: string[],
 *   spend_alerts: string[]
 * }
 */


export async function fetchAlerts({ email } = {}) {
  // Use configured base if available; fallback to localhost used in app elsewhere
  const apiBase = getApiBase() || 'http://localhost:5000';
  // const apiBase = "http://localhost:5000";
  // Endpoint maintained; adjust if backend changes path
  const url = new URL(`${apiBase.replace(/\/$/, "")}/orc/latest_agent_alerts`);
  if (email) url.searchParams.set("email", email);

  const res = await fetch(url.toString(), { method: "GET" });
  if (!res.ok) throw new Error(`Failed to fetch alerts: ${res.status}`);
  const json = await res.json();
  // New structure: data is under json.alerts
  const a = json?.alerts || {};
  const generated_at = a?.generated_at || json?.generated_at || null;

  // Normalize to always return arrays and keep old top-level fallback
  const market_intel_alerts = Array.isArray(a?.market_intel_alerts)
    ? a.market_intel_alerts
    : Array.isArray(json?.market_intel_alerts)
    ? json.market_intel_alerts
    : [];
  const risk_perf_alerts = Array.isArray(a?.risk_perf_alerts)
    ? a.risk_perf_alerts
    : Array.isArray(json?.risk_perf_alerts)
    ? json.risk_perf_alerts
    : [];
  const spend_alerts = Array.isArray(a?.spend_alerts)
    ? a.spend_alerts
    : Array.isArray(json?.spend_alerts)
    ? json.spend_alerts
    : [];

  // Summary may appear nested or top-level
  const summary = a?.summary || json?.summary || null;

  return {
    ok: Boolean(json?.ok),
    email: a?.email || json?.email || email || null,
    generated_at,
    market_intel_alerts,
    risk_perf_alerts,
    spend_alerts,
    summary: summary
      ? {
          supplier_count: summary.supplier_count ?? null,
          total_spend: summary.total_spend ?? null,
          total_spend_formatted: summary.total_spend_formatted ?? null,
        }
      : null,
  };
}
